module.exports = __webpack_public_path__ + "img/ee3.9d12d546.svg";